import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Grid, IconButton } from '@mui/material';
import { PaginationOrder } from '@/common/types';
import { LocationsListHeaderWrapper } from './styles';

interface Props {
    showSort?: boolean;
    order?: PaginationOrder;
    onToggleOrder?: () => void;
}

export const LocationsListHeader = ({ showSort, order, onToggleOrder }: Props) => {
    return (
        <LocationsListHeaderWrapper container spacing={2}>
            <Grid item xs={2}>
                <strong>Location Name</strong>
                {showSort && onToggleOrder && (
                    <IconButton
                        size="small"
                        onClick={onToggleOrder}
                        aria-label={`Sort by name ${order === 'ASC' ? 'descending' : 'ascending'}`}
                    >
                        {order === 'ASC' ? (
                            <ArrowUpwardIcon fontSize="small" />
                        ) : (
                            <ArrowDownwardIcon fontSize="small" />
                        )}
                    </IconButton>
                )}
            </Grid>
            <Grid item xs={4}>
                <strong>Address</strong>
            </Grid>
            <Grid item xs={2}>
                <strong>Default Provider</strong>
            </Grid>
            <Grid item xs={2}>
                <strong>Timezone</strong>
            </Grid>
            <Grid item xs={4} />
        </LocationsListHeaderWrapper>
    );
};
